/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AnswersControllerUpdateMutationRequest, AnswersControllerUpdateMutationResponse, AnswersControllerUpdatePathParams, AnswersControllerUpdate400, AnswersControllerUpdate401, AnswersControllerUpdate403, AnswersControllerUpdate404 } from "../../models/checklistsController/AnswersControllerUpdate";

function getAnswersControllerUpdateUrl(id: AnswersControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/checklist-answers/${id}` as const }  
  return res
}

/**
 * @description Requires Edit reviews or Edit Playbooks (matching the parent application's template kind) — the permission that controls responding to an already-run application.
 * @summary Update a checklist answer
 * {@link /api/v1/checklist-answers/:id}
 */
export async function answersControllerUpdate(id: AnswersControllerUpdatePathParams["id"], data?: AnswersControllerUpdateMutationRequest, config: Partial<RequestConfig<AnswersControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<AnswersControllerUpdateMutationResponse, ResponseErrorConfig<AnswersControllerUpdate400 | AnswersControllerUpdate401 | AnswersControllerUpdate403 | AnswersControllerUpdate404>, AnswersControllerUpdateMutationRequest>({ method : "PATCH", url : getAnswersControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}